export default __webpack_public_path__ + "static/media/dashboard_logo.7ab74a8d.png";